import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import {
  useAtom,
  useAtomValue,
  useSetAtom,
} from 'infrastructure/state/jotai.wrapper'
import {
  copySourceNodeAtom,
  copySourceTreeAtom,
  selectedNodeAtom,
  workingTreeAtom,
  workingTreeIdMap,
} from './atoms'
import { CurriculaTree } from '../utility/CurriculaTree/CurriculaTree'
import { OutlinedButton } from 'shared/ui'

// This component is responsible for providing the UI from which
// the user can select the node to work on
export function WorkingTree() {
  const { tree } = useAtomValue(workingTreeAtom)
  const [selectedNode, setNode] = useAtom(selectedNodeAtom)
  const idMap = useAtomValue(workingTreeIdMap)

  const treeNodeButtons = useMemo(() => {
    return [
      {
        Element: () => <OutlinedButton size="small">Select</OutlinedButton>,
        onClick: setNode,
      },
    ]
  }, [setNode])

  if (!tree) return null

  return (
    <CurriculaTree
      tree={tree}
      nodeButtons={treeNodeButtons}
      selectedNodeId={selectedNode?.id}
      idMap={idMap}
    />
  )
}

// This component is responsible for providing the UI from which
// the user can select the parent and sibling node to copy or move a node into
export function SourceTree({ action }: { action: string }) {
  const sourceTree = useAtomValue(copySourceTreeAtom)
  const setSourceNode = useSetAtom(copySourceNodeAtom)

  const treeNodeButtons = useMemo(() => {
    return [
      {
        Element: () => <OutlinedButton size="small">{action}</OutlinedButton>,
        onClick: setSourceNode,
      },
    ]
  }, [setSourceNode])

  if (!sourceTree) return null

  return (
    <Box padding="10px">
      <Box>Select Source Node</Box>
      <CurriculaTree tree={sourceTree} nodeButtons={treeNodeButtons} />
    </Box>
  )
}
